"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const BookNewAppointmentFlow_1 = require("./BookNewAppointmentFlow");
const RebookAppointmentFlow_1 = require("./RebookAppointmentFlow");
const CancelAppointmentFooter_1 = require("./CancelAppointmentFooter");
const ConfirmAppointmentFooter_1 = require("./ConfirmAppointmentFooter");
const HandleAppointment_1 = require("./HandleAppointment");
const ConfirmCancelModalBody_1 = __importDefault(require("./ConfirmCancelModalBody"));
const Modal_1 = require("../../../components/Modal/Modal");
const classnames_1 = __importDefault(require("classnames"));
const BookingFlow = ({ bookingFlowType, appointment, toggleBookingModal, isModalOpen, setBookingFlowType, }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [status, setStatus] = (0, react_1.useState)();
    const handleStatusChange = (0, react_1.useCallback)((newStatus) => {
        setStatus(newStatus);
        setIsLoading(false);
    }, []);
    const getModalBody = () => {
        switch (bookingFlowType) {
            case 'book':
                return (0, jsx_runtime_1.jsx)(BookNewAppointmentFlow_1.BookNewAppointmentFlowBody, {});
            case 'rebook':
                return (appointment && ((0, jsx_runtime_1.jsx)(RebookAppointmentFlow_1.RebookAppointmentFlowBody, { appointment: appointment, bookingFlowType: bookingFlowType })));
            case 'confirmed':
            case 'unconfirmed':
                return appointment && (0, jsx_runtime_1.jsx)(HandleAppointment_1.HandleAppointmentBody, { appointment: appointment });
            case 'cancel':
            case 'confirm':
                return (appointment && ((0, jsx_runtime_1.jsx)(ConfirmCancelModalBody_1.default, { appointment: appointment, status: status, bookingFlowType: bookingFlowType })));
            default:
                return null;
        }
    };
    const getModalFooter = () => {
        switch (bookingFlowType) {
            case 'book':
                return (0, jsx_runtime_1.jsx)(BookNewAppointmentFlow_1.BookNewAppointmentFlowFooter, {});
            case 'rebook':
                return (0, jsx_runtime_1.jsx)(RebookAppointmentFlow_1.RebookAppointmentFlowFooter, {});
            case 'confirmed':
            case 'unconfirmed':
                return (appointment && ((0, jsx_runtime_1.jsx)(HandleAppointment_1.HandleAppointmentFooter, { appointment: appointment, setBookingFlowType: setBookingFlowType, bookingFlowType: bookingFlowType })));
            case 'cancel':
                return (appointment && ((0, jsx_runtime_1.jsx)(CancelAppointmentFooter_1.CancelAppointmentFooter, { appointment: appointment, toggleBookingModal: toggleBookingModal, setIsLoading: setIsLoading, handleStatusChange: handleStatusChange, isLoading: isLoading, status: status })));
            case 'confirm':
                return (appointment && ((0, jsx_runtime_1.jsx)(ConfirmAppointmentFooter_1.ConfirmAppointmentFooter, { appointment: appointment, toggleBookingModal: toggleBookingModal, setIsLoading: setIsLoading, handleStatusChange: handleStatusChange, isLoading: isLoading, status: status })));
            default:
                return null;
        }
    };
    const modalTitle = (() => {
        switch (bookingFlowType) {
            case 'book':
                return __.trans('booking.book-new-appointment');
            case 'rebook':
                return __.trans('booking.rebooking-appointment');
            case 'confirmed':
                return __.trans('booking.handle-booking');
            case 'unconfirmed':
                return __.trans('booking.confirmation-new');
            case 'cancel':
                return __.trans('booking.cancel-booking');
            case 'confirm':
                return __.trans('booking.confirmation-new');
            default:
                return '';
        }
    })();
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { isOpen: isModalOpen, toggle: toggleBookingModal, title: modalTitle, footer: getModalFooter(), className: (0, classnames_1.default)('booking-modal', bookingFlowType), "aria-labelledby": "modal-title", "aria-describedby": "modal-description", children: (0, jsx_runtime_1.jsx)("div", { children: getModalBody() }) }));
};
exports.default = BookingFlow;
